import React, { memo } from "react";
import useMerchantStats from "./index.hooks";
import { Box, Grid, TextField, Typography } from "@material-ui/core";
import {
  SubscribedAndReachedPerEventBarChart,
  DevicesPerDayLinearChart,
  DevicesInfoCharts,
  FilterToolbar,
  CustomDatePickerToolbar,
} from "../../components";
import { DatePicker, LocalizationProvider } from "@material-ui/pickers";
import * as adapter from "@material-ui/pickers/adapter/moment";
import { StatsFilters } from "../../redux-store/slices/stats/interfaces";
import moment from "moment";

type MerchantStatsProps = {};

const MerchantStats = ({}: MerchantStatsProps) => {
  const { styles, classes, atomicStyles, t } = useMerchantStats();

  return (
    <Grid container>
      <Grid item className={styles.chartContainer}>
        <Box pt={2} ml={1}>
          <Typography variant="h4" color="primary">
            {t("Statistiche")}
          </Typography>
        </Box>
        <FilterToolbar />
        <CustomDatePickerToolbar />
        <SubscribedAndReachedPerEventBarChart />
        <DevicesPerDayLinearChart />
        <DevicesInfoCharts />
      </Grid>
    </Grid>
  );
};

export default memo(MerchantStats);
